export function keys<T extends object>(value: T): Array<keyof T & string> {
  return Object.keys(value) as Array<keyof T & string>;
}

export function objToDictLiteral(obj: { [key: string]: string }): string {
  const pairs = Object.keys(obj).map((key) => `'${key}': ${obj[key]}`);
  return `{${pairs.join(", ")}}`;
}
